import React, { useState, useContext } from "react";

import {
  makeStyles,
  AppBar,
  Toolbar,
  Typography,
  MenuItem,
  IconButton,
  Menu,
} from "@material-ui/core";

import AccountCircle from "@material-ui/icons/AccountCircle";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";
import { i18n } from "../translate/i18n";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100vh",
    [theme.breakpoints.down("sm")]: {
      height: "calc(100vh - 56px)",
    },
  },

  toolbar: {
    paddingRight: 20,
    paddingLeft: 16,
    backgroundColor: "transparent",
    textAlign: "center",
    color: "#E2E8F0",
    gap: theme.spacing(1),
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: "#225b7f",
    color: "#051c3a",
    borderBottom: "1px solid rgba(255, 255, 255, 0.08)",
    boxShadow: "0 10px 24px rgba(15, 23, 42, 0.25)",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
    color: "#E2E8F0",
  },
  title: {
    flexGrow: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  logo: {
    height: 52,
    display: "block",
    marginTop: 4,
  },
  appBarSpacer: {
    minHeight: "56px",
  },
  content: {
    flex: 1,
    overflow: "auto",
    backgroundColor: theme.palette.background.default,
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
}));

const LoggedInLayout = ({ children }) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const { handleLogout, loading } = useContext(AuthContext);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setMenuOpen(false);
  };

  const handleClickLogout = () => {
    handleCloseMenu();
    handleLogout();
  };

  if (loading) {
    return <BackdropLoading />;
  }

  return (
    <div className={classes.root}>
      <AppBar
        position="absolute"
        className={classes.appBar}
        color="primary"
      >
        <Toolbar variant="dense" className={classes.toolbar}>
          <div className={classes.title}>
            <img
              src={`${process.env.PUBLIC_URL}/logo-goneedited.png`}
              alt="WhatsContabil"
              className={classes.logo}
            />
          </div>
          <Typography
            variant="caption"
            style={{
              color: "rgba(226,232,240,0.8)",
              letterSpacing: "0.12em",
              textTransform: "uppercase",
            }}
          ></Typography>

          <div>
            <IconButton
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleMenu}
              color="inherit"
              style={{ color: "#ffffff" }}
            >
              <AccountCircle />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorEl}
              getContentAnchorEl={null}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={menuOpen}
              onClose={handleCloseMenu}
            >
              <MenuItem onClick={handleClickLogout}>
                {i18n.t("mainDrawer.appBar.user.logout")}
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />

        {children ? children : null}
      </main>
    </div>
  );
};

export default LoggedInLayout;

